import React from "react";
import { Text, Card, Table, TableBody, TableRow, TableCell } from "@jsq/ds/core";
import Money from "../../../Money";
import { cardTitle, tableRow, tableCell } from "./styles_vanilla.css";
import { InvoiceDetailsCardProps } from "./types";

export const InvoiceDetailsCard: React.FC<InvoiceDetailsCardProps> = ({
  vendorName,
  entityName,
  invoiceNumber,
  invoiceAmount,
  invoiceDate,
  dueDate,
  invoiceDescription,
}) => {
  return (
    <Card padding="lg">
      <Text className={cardTitle} variant="secondary-md">
        INVOICE DETAILS
      </Text>
      <Table condensed>
        <TableBody>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Vendor</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{vendorName}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Investment entity</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{entityName}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Invoice number</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{invoiceNumber || ""}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Invoice amount</Text>
            </TableCell>
            <TableCell>
              <Money money={invoiceAmount} rounded={false} />
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Invoice date</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{invoiceDate}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text variant="secondary-md">Due date</Text>
            </TableCell>
            <TableCell>
              <Text variant="regular-md">{dueDate}</Text>
            </TableCell>
          </TableRow>
          {invoiceDescription && (
            <TableRow className={tableRow}>
              <TableCell className={tableCell}>
                <Text variant="secondary-md">Invoice description</Text>
              </TableCell>
              <TableCell>
                <Text variant="regular-md">{invoiceDescription}</Text>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
};

export type { InvoiceDetailsCardProps } from "./types";
